/** @type {[string, string][]} */
const localeOptions = [
  ['en-US', 'English (US)'],
  ['en-US-TX', 'English (Texas)'],
  ['en-US-CA', 'English (California)'],
  ['en-GB', 'English (UK)'],
  ['en-CA', 'English (Canada)'],
  ['en-AU', 'English (Australia)'],
  ['es-ES', 'Spanish (Spain)'],
  ['es-MX', 'Spanish (Mexico)'],
  ['es-US', 'Spanish (US)'],
  ['ar-AE', 'Arabic (UAE)'],
  ['ar-EG', 'Arabic (Egypt)'],
  ['ar-SA', 'Arabic (Saudi Arabia)'],
  ['fr-FR', 'French (France)'],
  ['de-DE', 'German (Germany)'],
  ['it-IT', 'Italian (Italy)'],
  ['pt-BR', 'Portuguese (Brazil)'],
  ['ko-KR', 'Korean (South Korea)'],
  ['hi-IN', 'Hindi (India)'],
  ['id-ID', 'Indonesian (Indonesia)'],
  ['uk-UA', 'Ukrainian (Ukraine)'],
  ['nb-NO', 'Norwegian (Norway)'],
  ['hu-HU', 'Hungarian (Hungary)'],
  ['pl-PL', 'Polish (Poland)'],
  ['ru-KZ', 'Russian (Kazakhstan)'],
];

const SupportedLocales = localeOptions.map(([key]) => key);

const DefaultLocale = 'en-US';

module.exports = { localeOptions, SupportedLocales, DefaultLocale };
